import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import WebinarsHub from "@/pages/WebinarsHub";
import WebinarLanding from "@/pages/WebinarLanding";
import WebinarRegister from "@/pages/WebinarRegister";
import WebinarConfirmed from "@/pages/WebinarConfirmed";
import Offer from "@/pages/Offer";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CoursePlayer from "@/pages/CoursePlayer";
import VerifyCertificate from "@/pages/VerifyCertificate";
import Industries from "@/pages/Industries";
import Admin from "@/pages/Admin";
import StaticPage from "@/pages/StaticPage";
import NotFound from "@/pages/NotFound";

const wrap = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={wrap(<Home />)} />
          <Route path="/courses" element={wrap(<Courses />)} />
          <Route path="/courses/:industryOrSlug" element={wrap(<CourseRouter />)} />
          <Route path="/webinars" element={wrap(<WebinarsHub />)} />
          <Route path="/webinars/:topic" element={wrap(<WebinarLanding />)} />
          <Route path="/webinar/:instanceId/register" element={wrap(<WebinarRegister />)} />
          <Route path="/webinar/registered" element={wrap(<WebinarConfirmed />)} />
          <Route path="/offer/:industry" element={wrap(<Offer />)} />
          <Route path="/industries" element={wrap(<Industries />)} />
          <Route path="/how-it-works" element={wrap(<StaticPage page="how-it-works" />)} />
          <Route path="/about" element={wrap(<StaticPage page="about" />)} />
          <Route path="/contact" element={wrap(<StaticPage page="contact" />)} />
          <Route path="/terms" element={wrap(<StaticPage page="terms" />)} />
          <Route path="/privacy" element={wrap(<StaticPage page="privacy" />)} />
          <Route path="/refund" element={wrap(<StaticPage page="refund" />)} />
          <Route path="/cookies" element={wrap(<StaticPage page="cookies" />)} />
          <Route path="/verify" element={wrap(<VerifyCertificate />)} />
          <Route path="/verify/:certId" element={wrap(<VerifyCertificate />)} />
          <Route path="/login" element={wrap(<Login />)} />
          <Route path="/register" element={wrap(<Register />)} />
          <Route path="/auth/callback" element={wrap(<AuthCallback />)} />
          <Route path="/checkout" element={<ProtectedRoute>{wrap(<Checkout />)}</ProtectedRoute>} />
          <Route path="/payment/:status" element={<ProtectedRoute>{wrap(<PaymentResult />)}</ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute>{wrap(<Dashboard />)}</ProtectedRoute>} />
          <Route path="/learn/:slug" element={<ProtectedRoute><CoursePlayer /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute admin>{wrap(<Admin />)}</ProtectedRoute>} />
          <Route path="*" element={wrap(<NotFound />)} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </AppProvider>
  );
}

// Routes /courses/ai (industry) or /courses/ai-3-hour (slug)
import { useParams } from "react-router-dom";
const INDUSTRIES = ["ai", "real-estate", "insurance", "loans"];
function CourseRouter() {
  const { industryOrSlug } = useParams();
  return INDUSTRIES.includes(industryOrSlug) ? <Courses /> : <CourseDetail />;
}

export default App;
